// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const ChevronCompactUpIcon: Icon = ({ size = 18, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  const w = typeof size === 'number' ? size : Number(size) || 18;
  return (
    <svg
      width={w}
      height={w * (9 / 18)}
      viewBox="0 0 18 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="chevron compact up"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M16.5875 8.59502C16.3975 8.59502 16.2075 8.52502 16.0575 8.37502L9.53748 1.855C9.05748 1.375 8.27748 1.375 7.79748 1.855L1.2775 8.37502C0.9875 8.66502 0.5075 8.66502 0.2175 8.37502C-0.0725 8.08502 -0.0725 7.60502 0.2175 7.31502L6.73748 0.795C7.79748 -0.265 9.52748 -0.265 10.5975 0.795L17.1175 7.31502C17.4075 7.60502 17.4075 8.08502 17.1175 8.37502C16.9675 8.51502 16.7775 8.59502 16.5875 8.59502Z" fill={fill} />
    </svg>
  );
};

export { ChevronCompactUpIcon };
